/* eslint-disable multiline-ternary */
import React from "react"
import {
	Row, Col, Popconfirm, Empty
}from "antd"
import {
	Link
}from "react-router-dom"
import "./style.css"
import "antd/lib/card/style/index.css"
import "antd/lib/popconfirm/style/css.js"
import NewsCard from "../NewsCard"
import getDownloadTitleImageUrl from "../DownloadImageUrls"
import LocalLoading from "../../../components/Loading/Local"

const NewsList = (props) => {
	const {
		isModify,
		deleteOneNews,
		news,
		newsGrid,
		restoreNews,
		showLoading
	} = props

	return (
		<>
			{ !showLoading?
				(<>
					{ news?.length ?
						(<>
							{ !isModify ? (
								<Row
									align="middle"
									className="news-row-main-container"
									gutter={ [25, 15] }
									justify="start"
								>
									{ news.map((el, index) => {
										return (
											<Col
												key={ index }
												className="main-news-col"
												lg={ newsGrid.lg }
												md={ newsGrid.md }
												sm={ newsGrid.sm }
												xl={ newsGrid.xl }
												xs={ newsGrid.xs }
												xxl={ newsGrid.xxl 	}
											>
												<NewsCard
													cardClassName="card"
													imageClassName="newsImage"
													imageContainerClassName="news-image-container"
													oneNews={ el }
													titleContainerClassName="cardText-last cardText-newsList"
												/>
											</Col>
										)
									}) }
								</Row>
							):(<Row
								align="middle"
								className="news-row-padder"
								gutter={ [25, 15] }
								justify="start"
								type="flex"
							   >
								{
									news.map((el, index) => {
										return (
											<Col
												key={ index }
												className="main-news-col"
												md={ 12 }
												sm={ 24 }
												xl={ 8 }
											>

												<div>
													<div className="manage-image-container">
														<div>
															<img
																alt="news_image"
																className="newsImage"
																src={ getDownloadTitleImageUrl(el.titleImageId, el.id) }
															/>
														</div>
														<div className="cardActions">
															<Popconfirm
																cancelText="Нет"
																okText="Да"
																title={ `Вы уверены, что хотите ${ !el.isDeleted ? "удалить новость" : "восстановить новость" }` }
																onConfirm={ () => (!el.isDeleted ? deleteOneNews({ id: el.id }) : restoreNews({ id: el.id })) }
															>
																<p className="action-name">
																	{ !el.isDeleted? "Удалить" : "Восстановить" }
																</p>
															</Popconfirm>
															{ !el.isDeleted &&
														<>
															<p>
															|
															</p>
															<Link to={ `/editNews/${ el.id }` }>
																<p className="action-name">
																Изменить
																</p>
															</Link>
														</> }
														</div>
													</div>
													<Link to={ `/oneNews/${ el.id }` }>
														<div className="cardText-last cardText-newsList">
															<h4>
																{ el.title }
															</h4>
														</div>
													</Link>
												</div>
											</Col>
										)
									})
								}
							</Row>) }
						</>)
					 : (
							<Empty />
						) }
				</>)
				: <LocalLoading /> }
		</>

	)
}

export default NewsList
